import React from 'react';
import styled from 'styled-components';

// Renders text beneath a checkbox with validation errors
const CheckboxHelp = styled.small`
  display: block;
  font-size: 0.875rem;
  color: #dc3545;
  margin-top: 0.5rem;
`;

// Checkbox can render in red if it has a validation issue
const Checkbox = styled(({children, invalid, validationText, ...props}) => (
  <div {...props}>
    <label>{children}</label>
    {invalid && validationText ? <CheckboxHelp>{validationText}</CheckboxHelp> : null}
  </div>
))`
  ${props => {
    if (props.invalid) {
      return `
        label {
          color: #dc3545;
        }

        input[type="checkbox"] {
          outline: 1px solid #dc3545;
          outline-offset: 2px;
        }
      `;
    }
  }}
`;

export default Checkbox;
